import { FC } from 'react';
import 'shared/common/assets/colors.css';
import { withCommonProviders } from '../../../common/containers/CommonContextProviders';
import { SubsidizedMortgageContainer } from '../SubsidizedMortgageContainer';
import { IApplicationCommonRootComponentProps } from '../../../common/types/applicationRootComponent';
import { SubsidizedMortgageContainerWithBtn } from '../SubsidizedMortgageContainerWithBtn';

export const SubsidizedCalculatorApp: FC<IApplicationCommonRootComponentProps> = withCommonProviders(({ context }) => {
  const { withButton } = context.custom;

  return withButton ? <SubsidizedMortgageContainerWithBtn /> : <SubsidizedMortgageContainer />;
});
